import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";
import { InternalAHTCategoryType } from "@callveriq/type/ahtAnalysis";

export const internalAHTApiSlice = createApi({
    reducerPath: "internalAHTApiSlice",
    baseQuery: axiosBaseQuery(),
    tagTypes: ["InternalAHT"],
    endpoints: (builder) => ({
        getInternalAHT: builder.query<InternalAHTCategoryType[], void>({
            query: () => "/customer_intelligence/aht/category/",
            providesTags: ["InternalAHT"],
        }),
        createInternalAHT: builder.mutation<
            InternalAHTCategoryType,
            Omit<InternalAHTCategoryType, "id">
        >({
            query: (data) => ({
                url: "/customer_intelligence/aht/category/",
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["InternalAHT"],
        }),
        updateInternalAHT: builder.mutation<
            InternalAHTCategoryType,
            InternalAHTCategoryType
        >({
            query: (data) => ({
                url: `/customer_intelligence/aht/category/${data.id}/`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["InternalAHT"],
        }),

        deleteInternalAHT: builder.mutation<void, number>({
            query: (id) => ({
                url: `/customer_intelligence/aht/category/${id}/`,
                method: "DELETE",
            }),
            invalidatesTags: ["InternalAHT"],
        }),
    }),
});

export const {
    useGetInternalAHTQuery,
    useCreateInternalAHTMutation,
    useUpdateInternalAHTMutation,
    useDeleteInternalAHTMutation,
} = internalAHTApiSlice;
